import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/core/application/security/useAuthStore';

interface ClinicianGuardProps {
  children: React.ReactNode;
}

/**
 * Guard ReBAC para las rutas /pro/*.
 * Sólo usuarios con el claim JWT `isClinico = true` (inyectado por `fn_custom_jwt_hook`)
 * pueden acceder al módulo "Mi Consultorio".
 *
 * Una secretaria de equipo (isSecretaria=true, isClinico=false)
 * es redirigida a /hub para que no pueda escalar privilegios.
 */
export function ClinicianGuard({ children }: Readonly<ClinicianGuardProps>) {
  const { isClinico, isInitialized, isFetchingFallback } = useAuthStore();
  const location = useLocation();

  // Esperar hasta que la sesión esté inicializada Y los roles (fallback RPC) cargados
  if (!isInitialized || isFetchingFallback) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-slate-950">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-700 border-t-white"></div>
      </div>
    );
  }

  // Si no es clínico verificado, denegar acceso.
  if (!isClinico) {
    return <Navigate to="/hub" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
